import { ReactNode } from 'react';
import { LoadingError } from '@sd/shared';
import { Loader } from '../Loader/Loader';
import { Alert } from 'react-bootstrap';
import { ImpersonationDetails } from '../ImpersonationDetails/ImpersonationDetails';
import { Icon, IconVariant } from '@sd/components';
import { GlobalMessage } from '../GlobalMessage/GlobalMessage';
import { Message } from '@sd/prism';

type ToastProps = {
  type: 'success' | 'warning' | 'error' | 'info';
  message: string;
  icon: IconVariant;
  link?: ReactNode;
};

type Props = {
  heading: string;
  loading?: boolean;
  loadingError?: LoadingError;
  children?: ReactNode;
  toast?: ToastProps;
};

export const SceneContainer = ({ loading, loadingError, heading, children, toast }: Props) => {
  return (
    <>
      <ImpersonationDetails />
      <GlobalMessage />
      {loadingError && (
        <div className="row">
          <div className="col-lg-6 mb-2">
            <Message data-testid="loading-error" color="danger" className="mx-0">
              {loadingError.message}
            </Message>
          </div>
        </div>
      )}
      {toast && (
        <div className="row">
          <div className="col-lg-6 mb-2">
            <Toast type={toast.type} message={toast.message} icon={toast.icon} link={toast.link} />
          </div>
        </div>
      )}
      <h2 className="mb-1">{heading}</h2>
      <Loader loading={loading}>{children}</Loader>
    </>
  );
};

const Toast = ({ type, message, icon, link }: ToastProps) => (
  <Alert variant={type}>
    <Icon variant={icon} />
    &nbsp;&nbsp;{message}&nbsp;&nbsp;
    {link}
  </Alert>
);
